import SvgIcon from '@material-ui/core/SvgIcon';

function StatusFail(props) {
  return (
    <SvgIcon width="48" height="48" viewBox="0 0 48 48" fill="none" {...props}>
      <circle cx="24" cy="24" r="23" stroke="#E42313" strokeWidth="2" />
      <g clipPath="url(#clip0_5_3761)">
        <path
          d="M33.1899 33.1901L14.8099 14.8101L13.3899 16.2201L18.0899 20.9101L16.9999 22.0001H19.1699L20.9999 23.8301V28.0001H25.1699L27.1699 30.0001H16.9999V32.0001H29.1699L31.7799 34.6101L33.1899 33.1901Z"
          fill="#E42313"
        />
        <path
          d="M26.9999 22H30.9999L23.9999 15L20.9099 18.09L26.9999 24.17V22Z"
          fill="#E42313"
        />
      </g>
      <defs>
        <clipPath id="clip0_5_3761">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(12 12)"
          />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default StatusFail;
